//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ExpressionCollectorSetList.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.TwoExpressionsCollectorSetList.js";
import "../no/ScCollector.js";
let d=[[[0,"AngleTolerance",1,0],[0,"Direction",1,"Direction",0],[0,"DistanceTolerance",1,0],[0,"DraftAllInstances",1,0],[0,"DraftBothSides",1,0],[0,"DraftIsoclineOrTruedraft",1,0],[0,"DraftReferencesMethod",1,0],[1,"EdgeSetAngleExpressionList",0,"ExpressionCollectorSetList",0],[1,"FaceSetAngleExpressionList",0,"ExpressionCollectorSetList",0],[1,"PartingReference",0,"ScCollector",0],[0,"StationaryEntity",1,"NXObject",1],[1,"StationaryPartingReference",0,"ScCollector",0],[1,"StationaryReference",0,"ScCollector",0],[0,"SymmetricAngle",1,0],[1,"TwoDimensionFaceSetsData",0,"GeometricUtilities.TwoExpressionsCollectorSetList",0],[0,"TypeOfDraft",1,0],[0,"VariableAngleData",0,"GeometricUtilities.DraftVariableAngleData",0]],[[[],"SetVariableAngleOption",{},0,0]],[]];
SPLM.Features.DraftBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.DraftBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.DraftBuilder.Method = Object.freeze({
    "Isocline" : "Isocline", "TrueDraft" : "TrueDraft"});

SPLM.Features.DraftBuilder.Type = Object.freeze({
    "Face" : "Face", "Edge" : "Edge", "Tangent" : "Tangent", "PartingEdge" : "PartingEdge"});

SPLM.Features.DraftBuilder.DraftReferencesMethods = Object.freeze({
    "StationaryFace" : "StationaryFace", "PartingFace" : "PartingFace", "StationaryAndPartingFace" : "StationaryAndPartingFace"});

export default SPLM;